import { DateTime } from 'luxon';

// Keeps selected report dates through today on the axis, even when no shifts have data.
export function getShiftDelayDays(start: Date, end: Date, now = new Date()): string[] {
    let day = DateTime.fromJSDate(start).setZone('Europe/Helsinki').startOf('day');
    const endDay = DateTime.fromJSDate(end).setZone('Europe/Helsinki').startOf('day');
    const today = DateTime.fromJSDate(now).setZone('Europe/Helsinki').endOf('day');
    const days: string[] = [];

    while (day < endDay && day <= today) {
        days.push(day.toISODate()!);
        day = day.plus({ days: 1 });
    }

    return days;
}
